module.exports = __webpack_public_path__ + "img/Selo_Melhores_GPTW-2020.3c3e8503.png";